import i18n from 'shared/lib/i18n';

export const getReservationStatusOptions = () => [
  { value: 'pending', label: i18n.t('status.pending') },
  { value: 'denied', label: i18n.t('status.denied') },
  { value: 'canceled', label: i18n.t('status.canceled') },
  { value: 'success', label: i18n.t('status.success') },
];

export const getReservationMultiStatusOptions = () => [
  { value: 'pending', label: i18n.t('status.pending') },
  { value: 'denied', label: i18n.t('status.denied') },
  { value: 'canceled', label: i18n.t('status.canceled') },
  { value: 'approved', label: i18n.t('status.approved') },
];
